var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search--banner"},[_c('div',{staticClass:"d-flex justify-center"},[(_vm.banner)?_c('img',{attrs:{"src":_vm.banner.image,"alt":"Search Banner"},on:{"click":_vm.openLink}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }